export default "__VITE_ASSET__26841332__"